import React from "react";

export default function Missing() {
  return (
    <div className="app-shell qf-section">
      <div className="qf-wrap center-narrow qf-stack">
        <h1 className="qf-title">Nothing to see here</h1>
        <p className="qf-lead">This is a private link-based tool. If you were sent a link, open that link directly.</p>
      </div>
    </div>
  );
}
